/// <amd-module name="Reporting/CFDReport/CfdReportTeachingBubbleHelper" />
import { ReportGuidedTourUtilityProps } from "Reporting/BoardsCommon/ReportGuidedTourUtility";
import * as Resources from "Reporting/CFDReport/Resources";
import { getCFDReportSettingsStorageKey } from "./CfdReportUserSettings";

export function getTeachingBubblesData(): ReportGuidedTourUtilityProps {
    return {
        reportKey: getCFDReportSettingsStorageKey(),
        tourBubble: {
            title: Resources.TourBubbleTitle,
            text: Resources.TourBubbleText
        },
        filterBubble: {
            title: Resources.FilterBubbleTitle,
            text: Resources.FilterBubbleText
        },
        chartBubble: {
            title: Resources.ChartBubbleTitle,
            text: Resources.ChartBubbleText
        },
        legendBubble: {
            title: Resources.LegendBubbleTitle,
            text: Resources.LegendBubbleText
        },
        reportDocumentationUrl: "https://go.microsoft.com/fwlink/?linkid=2095909"
    };
}
